module.exports = __webpack_public_path__ + "img/proudly-serving.9dd1e420.jpg";